// search.js
// initial state
const state = {
	currentKey: ''
}

// mutations
const mutations = {
	//
	changeKey(state, value) {
		state.currentKey = value;
	}
}

export default {
	state,
	mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js